var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('add-post',_vm._b({attrs:{"parent-id":_vm.parentId,"place-holder-text":_vm.placeHolderText,"comment-count":_vm.commentCountValue,"show-comments-for-all-networks":true}},'add-post',_vm.commentProps,false))}
var staticRenderFns = []

export { render, staticRenderFns }